import { render, staticRenderFns } from "./Deroga.vue?vue&type=template&id=ce13dce4&scoped=true&"
import script from "./Deroga.vue?vue&type=script&lang=js&"
export * from "./Deroga.vue?vue&type=script&lang=js&"
import style0 from "./Deroga.vue?vue&type=style&index=0&id=ce13dce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce13dce4",
  null
  
)

export default component.exports